import Typography from 'components/curo-components/common/Typography';
import { GoogleAnalyticsEventType } from 'enums/GoogleAnalyticsEventType';

import { ILoanOfferAction } from './SelectLoanOffer.types';
import styles from './SelectLoanOfferStep.module.scss';
import {
  parseLoanOffersToLoanOfferItem,
  parseRefinanceLoanOffersToLoanOfferItem,
} from './constants';

interface ILoanOfferConfig {
  title: string;
  analyticsEvent: GoogleAnalyticsEventType;
  parser: typeof parseLoanOffersToLoanOfferItem | typeof parseRefinanceLoanOffersToLoanOfferItem;
  tableRows: number;
  tableColumns: number;
  saveOptions?: {
    isPPCJourneyLoanOffer?: boolean;
  };
  secondaryActions?: ILoanOfferAction[];
  disclaimer?: React.ReactNode;
}

export const createOnlineConfig = (borrower: string): ILoanOfferConfig => ({
  title: `Congrats ${borrower}, you're pre-qualified for a loan!`,
  analyticsEvent: GoogleAnalyticsEventType.ApplyProcessOnlineOffer,
  parser: parseLoanOffersToLoanOfferItem,
  tableRows: 2,
  tableColumns: 2,
});

export const createRefiConfig = (borrower: string): ILoanOfferConfig => ({
  title: `Congrats ${borrower}, You're approved for a Refinance!`,
  analyticsEvent: GoogleAnalyticsEventType.ApplyProcessOnlineOfferRefi,
  parser: parseRefinanceLoanOffersToLoanOfferItem,
  tableRows: 4,
  tableColumns: 2,
});

export const createPPCConfig = (onCancel?: () => any): ILoanOfferConfig => ({
  title:
    'You are not approved for the advertised loan. However, you’re prequalified for another Heights Finance loan.',
  analyticsEvent: GoogleAnalyticsEventType.ApplyProcessPPCJourneyOffer,
  parser: parseLoanOffersToLoanOfferItem,
  tableRows: 2,
  tableColumns: 2,
  saveOptions: {
    isPPCJourneyLoanOffer: true,
  },
  secondaryActions: onCancel
    ? [
        {
          label: 'Not Interested',
          kind: 'secondary',
          onClick: onCancel,
        },
      ]
    : [],
  disclaimer: (
    <>
      <div className={styles.smallText}>*</div>

      <Typography className={styles.smallText}>
        Final approval is conditional based on verification of identity, address, monthly income and
        expenses. To proceed with this offer and continue the loan process click "Accept My Offer"
        below.
      </Typography>
    </>
  ),
});
